import { render, staticRenderFns } from "./materialAlteration.vue?vue&type=template&id=4bf7528c"
import script from "./materialAlteration.vue?vue&type=script&lang=js"
export * from "./materialAlteration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports